import _Object$assign from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/core-js/object/assign';
import _getIterator from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/core-js/get-iterator';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// Recursive find files in {srcDir}/{dir.store}
var files = require.context('@/store', true, /^\.\/(?!-)[^.]+\.(js)$/);
var filenames = files.keys();

// Store
var storeData = {};

// Check if {dir.store}/index.js exists
var indexFilename = void 0;
filenames.forEach(function (filename) {
  if (filename.indexOf('./index.') !== -1) {
    indexFilename = filename;
  }
});
if (indexFilename) {
  storeData = getModule(indexFilename);
}

// If store is not an exported method = modules store
if (typeof storeData !== 'function') {

  // Store modules
  if (!storeData.modules) {
    storeData.modules = {};
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(filenames), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var filename = _step.value;

      var name = filename.replace(/^\.\//, '').replace(/\.(js)$/, '');
      if (name === 'index') continue;

      var namePath = name.split(/\//);
      var module = getModuleNamespace(storeData, namePath);

      name = namePath.pop();
      module[name] = getModule(filename);
      module[name].namespaced = true;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

// createStore
export var createStore = storeData instanceof Function ? storeData : function () {
  return new Vuex.Store(_Object$assign({
    strict: process.env.NODE_ENV !== 'production'
  }, storeData, {
    state: storeData.state instanceof Function ? storeData.state() : {}
  }));
};

// Dynamically require module
function getModule(filename) {
  var file = files(filename);
  var module = file.default || file;
  if (module.commit) {
    throw new Error('[nuxt] store/' + filename.replace('./', '') + ' should export a method which returns a Vuex instance.');
  }
  if (module.state && typeof module.state !== 'function') {
    throw new Error('[nuxt] state should be a function in store/' + filename.replace('./', ''));
  }
  return module;
}

function getModuleNamespace(storeData, namePath) {
  if (namePath.length === 1) {
    return storeData.modules;
  }
  var namespace = namePath.shift();
  storeData.modules[namespace] = storeData.modules[namespace] || {};
  storeData.modules[namespace].namespaced = true;
  storeData.modules[namespace].modules = storeData.modules[namespace].modules || {};
  return getModuleNamespace(storeData.modules[namespace], namePath);
}


//////////////////
// WEBPACK FOOTER
// ./.nuxt/store.js
// module id = ./.nuxt/store.js
// module chunks = 18